// extracted by mini-css-extract-plugin
export default {"losange":"skill_losange__Ub9wZ","los1":"skill_los1__NEN5m","img":"skill_img__gPcsy","image":"skill_image__ClksQ","tag":"skill_tag__K0f4C","start":"skill_start__9MO1R"};